export default __webpack_public_path__ + "static/media/icon_editor_ol.81f480bc.svg";